import { render, staticRenderFns } from "./TileBase.vue?vue&type=template&id=ba2087ba&scoped=true&lang=html&"
import script from "./TileBase.vue?vue&type=script&lang=js&"
export * from "./TileBase.vue?vue&type=script&lang=js&"
import style0 from "./TileBase.vue?vue&type=style&index=0&id=ba2087ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2087ba",
  null
  
)

export default component.exports